/**
 * @file        build.js
 *              Provide build information for DCP rtlink code, the same way as the dcp/build
 *              module is injected for dcp-client code.  That is what src/common/dcp-build.js
 *              was supposed to do. We collide symbols here with a dcp-client built-in, so
 *              that the code works the same everywhere but a gives different results depending
 *              on how it was linked.
 *
 *              This file is expressly processed by the copy-stamp rule in the core install
 *              map, so that the symbols in here get substituted with their 'real' values as
 *              the product is installed. A side effect of this is that dev versions running
 *              out of the source tree will have symbol names instead of symbol values here.
 *
 * @author      Wes Garland, wes@distributive.network
 * @date        Nov 2022
 */

exports.version = 'a9e7f7e03401b8d2862f565386a9389324636c8e';
exports.branch = 'HEAD';

/* When/how configure.sh ran */
exports.config = require('../etc/local-config.json');
delete exports.config.install;

/* When/how install.sh ran (not for dcp-client) */
exports.install = {
  timestamp: new Date(Number('__TIMESTAMP__') * 1000),
  build: '__DCP_BUILD',
};


